/**=========================================================
 * Module: reviewers.js
 * Reviewers Controller
 =========================================================*/

 App.controller('ReviewersController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$filter',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $filter) {
   "use strict";

   $scope.type = 'account';
   $scope.filter = 'customRole=REVIEWER&_disabled=false';

   $scope.data = {};
   $scope.languages = []

   $scope.page = {
           title: 'labels.REVIEWERS',
           subTitle: ''
       };

   $scope.initialized = false;
   $scope.watchActivated = false;
   $scope.init = function(){

       if($rootScope.user.id && $rootScope.user.groupType=='CLIENT' && $rootScope.user.group.opts.hasReviewInProject){
           $scope.initialized = true;

           

                   $scope.lastCursor = '';

                   $scope.loadMore = function(){
                       $scope.load(100, $scope.lastCursor, Infinity);
                   };
                   $scope.load = function(range, cursor, times){
                       var filter = $scope.filter;
                       if(cursor) {
                           if(filter) filter += '&';
                           filter += '_cursor='+cursor;
                       }
                       if(filter) filter += '&';
                       filter += '_range=' + range;
                       if(!cursor) $scope.data = [];
                       
                       D.query($scope.type, filter, { cache: false }).then(
                                   function(response){
                                       for(var i=0; i<response.length; i++){
                                           var lang = response[i].opts.reviewLanguage
                                           if(!$scope.data[lang]) {
                                               $scope.languages.push({code:lang,label:$filter('translate')('enums.language.'+lang)})
                                               $scope.data[lang] = []
                                           }
                                           $scope.data[lang].push(response[i])
                                       }

                                       $scope.languages.sort(function(a, b) { return a.label > b.label ? 1 : -1})

                                       $scope.lastCursor = response.cursor;

                                       if((response.length===range || response.queryRL===range) && response.cursor){
                                           if(times-1>0 || (response.length<response.queryRL && $scope.data.length<1000))
                                               $scope.load(100, response.cursor, times-1);
                                           else{
                                               
                                           }
                                       } else {
                                           
                                       }
                                   },
                                   function(error){
                                       $scope.error = error;
                                   }
                               ).catch(console.error);
                   };
                   $scope.load(1000, '', 1);

       } else {
           if(!$scope.watchActivated){
               $scope.watchActivated = true;
               $rootScope.$watch('user.id', function(){
                   if(!$scope.initialized){
                       $scope.init();
                   }
               });
           }
       }
   }

   $scope.init();

   $scope.$on('$destroy', function iVeBeenDismissed() {
     // say goodbye to your controller here
     // release resources, cancel request...
     $scope.load = function() { };
   });
}]);
